module.exports = __webpack_public_path__ + "static/mentor-sandhir-945d24fb90f73d605fa2ef1aa3c1ac0a.png";